<template>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                    <div class="row breadcrumbs-top">
                    <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" >Pallet Scan Details </h3>
                        <div class="breadcrumb-wrapper">
                            <ol class="breadcrumb">
                               
                                <li class="breadcrumb-item"><a href="#">Reports</a>
                            </li>
                            
                            <li class="breadcrumb-item active"> Analysis
                            </li>
                            <li class="breadcrumb-item active">Pallet Scans
                            </li>
                            </ol>
                        </div>
                    </div>
                    </div>
                </div>
            
            </div>
            <div class="content-body">
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
                <section>
                     <div class="card">
                        <div class="card-header py-1 filter_card_searchbgst_dock filter_rotation_onlick ">
                            <div class="container-fluid" @click="toggleCollapse">
                                <div class="row row fc_my-05">
                                     <div class="w-auto px-1 mobile-padding-0-2">
                                        <div class="avatar bg-light-secondary rounded d-inline-flex">
                                            <div class="avatar-content">
                                                <em data-feather='search' class="custom-class avatar-icon font-medium-3"></em>
                                            </div>
                                        </div>
                                     </div>
                                    <h4 class="card-title d-inline-flex "> Search Pallet Scan </h4>
                                </div>
                            </div>
                           
                        </div>
                        <div  v-if="isCollapsed" class="collapsed-div">
                            <div class="card-body pt-1">
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1">
                                        <label class="form-label text-left w-100">Vehicle No</label>
                                        <treeselect placeholder="Select Vehicle Number" v-model="search.vehicle_id" :options="search.vehicleNumberList"  />
                                        
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1">
                                        <label class="form-label text-left w-100">Scan From Date</label>
                                        <date-picker placeholder="From Date" v-model="search.start_date" valueType="format" class="startdate w-100" ></date-picker>
                                        
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 mb-1">
                                        <label class="form-label text-left w-100">Scan To Date</label>
                                        <date-picker placeholder="To Date" v-model="search.end_date" valueType="format" class="startdate w-100" ></date-picker>
                                        
                                    </div>
                                    
                                    <div class="col-12 col-sm-6 col-md-6 col-lg-3 text-right mb-1 all_buttons_style">
                                        <button type="submit" class="btn btn-relief-primary mt-2 mr-1" @click="getReports('report', search)">
                                            Search
                                        </button>
                                        <button type="submit" class="btn btn-relief-primary mt-2 mr-1" @click="resetFilters">
                                            clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="px-0">
                        <!-- <div class="card-header bg-white pt-1 px-1 border-bottom_eee rows">
                            <h4 class="card-title">Pallet Scans</h4>
                            <div v-if="isReportActive" class="">
                                <div class="input-group-append float-right">Total Records: {{report.totalcount}}</div>
                            </div>
                            <div  class="px-1 text-right mobile-padding-0-2">
                                <button type="button" class="btn--export" @click="exportData('pallet_scan', 'pallet_scans_report', 'updated_datetime', search)">Export</button> 
                            </div>
                        </div> -->
                        
                        <div class="col-lg-12 mt-0 px-0">
                            <div class="card text-center mb-1">
                            
                                <!-- <div class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0">
                                    <div class="tab-content">
                                        <div role="tabpanel" class="tab-pane active" id="report" aria-labelledby="report_tab" aria-expanded="true"> -->
                                            <div class="container px-0" >
                                                <div class="table-responsive datatableview">
                                                    <table class="table table-hover table-striped table_stickys table-col-td-white custom_doctable">
                                                        <thead>
                                                            <tr>
                                                                <th class="text-left align-middle">Pallet Code</th>
                                                                <th class="text-left align-middle">Vehicle No.</th>
                                                                <th class="text-left align-middle">No. of packages</th>
                                                                <th  class="text-left align-middle">Source Dock</th>
                                                                <th  class="text-left align-middle">Target Dock</th>
                                                                <th  class="text-left align-middle">Is Unloaded</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <vue-element-loading :active="isReportDataLoading" />
                                                            <template v-for="(data,index) in report.list"  >
                                                                <tr @click="toggle(String(data.pallet_code) + '___' + String(data.gate_entry_id))">
                                                                    <td data-column="Pallet Code" class="text-left">{{data.pallet_code}}</td>
                                                                    <td data-column="Vehicle No." class="text-left">{{data.vehicle_number_plate}}</td>
                                                                    <td data-column="No. of packages" class="text-left">{{data.no_of_packages}}</td>
                                                                    <td data-column="Source Dock" class="text-left">{{data.source_dock_name}}</td>
                                                                    <td data-column="Target Dock" class="text-left">{{data.target_dock_name}}</td>
                                                                    <td data-column="Is Unloaded" class="text-center">{{data.is_unloaded ? "Yes" : "No"}}</td>
                                                                </tr>
                                                                <tr v-if="opened === String(data.pallet_code) + '___' + String(data.gate_entry_id)"  :class="{ opened: opened === String(data.pallet_code) + '___' + String(data.gate_entry_id) }" >
                                                                    <vue-element-loading :active="isShipmentsLoading" />
                                                                        <td colspan="100%" style="padding: 0px!important;">
                                                                        <div class="table-responsive datatableview" style="padding: 10px!important;">
                                                                            <table class="opened table table-hover table_stickys table-col-td-white custom_doctable">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th class="text-left align-middle">Docket No.</th>
                                                                                        <th class="text-left align-middle">Package No.</th>
                                                                                        <th class="text-left align-middle">Delivery OU</th>
                                                                                        <th class="text-left align-middle">Booking OU</th>
                                                                                        <th class="text-left align-middle">No. of packages in vehicle</th>
                                                                                        <th class="text-left align-middle">No. of packages in Docket</th>
                                                                                        <th class="text-left align-middle">Shipment actual weight</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    <template v-for="(ship, idx) of shipmentData">
                                                                                        <tr>
                                                                                            <td data-column="Shipment AWB" class="text-left">
                                                                                                {{ship.docket_no}}
                                                                                            </td>
                                                                                            <td data-column="Shipment AWB" class="text-left">
                                                                                                {{ship.shipment_awb}}
                                                                                            </td>
                                                                                            <td data-column="Delivery OU" class="text-left">
                                                                                                {{ship.delivery_ou}}
                                                                                            </td>
                                                                                            <td data-column="Booking OU" class="text-left">
                                                                                                {{ship.booking_ou}}
                                                                                            </td>
                                                                                            <td data-column="No. of packages in vehicle" class="text-left">
                                                                                                {{ship.no_of_pkg_in_vehicle}}
                                                                                            </td>
                                                                                            <td data-column="No. of packages in docker" class="text-left">
                                                                                                {{ship.no_of_pkg_in_docket}}
                                                                                            </td>
                                                                                            <td data-column="Shipment actual weight" class="text-left">
                                                                                                {{ship.shipment_actual_weight}}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </template>
                                                                                    <template v-if="!shipmentData.length">
                                                                                      <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                                                                                    </template>
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </template>
                                                            <template v-if="!report.list.length">
                                                              <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                                                            </template>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div class="pageCenter text-center mt-4 pagination_viewallpages">
                                                    <pagination v-model="report.page" :records="report.totalcount" :per-page="report.pagelimit" @paginate="(e) => handlePageChange(e, 'report')"/>
                                                </div>
                                            </div>
                                        <!-- </div> -->
                                        <!-- <div role="tabpanel" class="tab-pane" id="chart" aria-labelledby="chart_tab" aria-expanded="false">
                                            <BarChart :chartData="chartData" />
                                            <hr />
                                            <PieChart :chartData="pieChartData" />
                                        </div> -->
                                    <!-- </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon } from 'vue-feather-icons';
import CONSTANT from "../../constants.js"
import { read, utils } from "xlsx";
// import schema from "../utils/schema";
import common_methods from "../../utils/common_methods"
import searchMasterNameList from "../../utils/searchMasterNameList"
import BarChart from "./Charts/BarChart.vue"
import PieChart from "./Charts/PieChart.vue"

export default({
    name:'PalletScans',
    mixins: [ common_methods, searchMasterNameList ],
    components: {
        Treeselect,
        DatePicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        BarChart,
        PieChart,
    },
    data() {
        return {
            isLoading: false,
            isShipmentsLoading: false,
            isReportDataLoading: false,
            isReportActive: true,
            reportData: [],
            isCollapsed: false,
            shipmentData: [],
            opened: null,
            search: {
                vehicleNumberList: [],
                vehicle_id: null,
                start_date: null,
                end_date: null
            },
            report: {
                url: "/reports/pallet_scan",
                list: [],
                totalcount: 0,
                pageCount: 0,
                page: 1,
                pagelimit: CONSTANT.LIMIT,
                currPageNum: 0,
                pageoffset: 1,
            },
        }
    } ,
    mounted(){
        if (!localStorage.getItem('reloaded')) {
            localStorage.setItem('reloaded', '1');
            location.reload();
        }
        if (feather) {
            feather.replace({
                width: 14,
                height: 14
            });
        }
        this.getReports()
        this.getVehicleNumberList()
        // this.getDataForAnalysis()
        // this.getPieChartDataForAnalysis()
    },
    methods: {
        resetFilters() {
            this.search.vehicle_id = null
            this.report.currPageNum = 0
            this.report.page = 1
            this.report.pageoffset = 1
            this.search.start_date = null
            this.search.end_date = null
            this.getReports()
        },
        getVehicleNumberList() {
            this.searchNameMasterList('vehicle_registration_master', 'vehicle_number_plate', null, 'vehicle_id', 'vehicle_transaction_type')
                .then(result => {
                    console.log(result.data)
                  this.search.vehicleNumberList = result.data
                })
                .catch(e => {
                  this.displayError(e)
                })
        },
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
        },
        toggle(id) {
            const isOpen = this.opened === id;
            if(isOpen) {
                this.opened = null
            } else {
                this.opened = id
                this.isShipmentsLoading = true
                let [pallet_code, gate_entry_id] = id.split("___")
                let url = `/reports/pallet_scan/${pallet_code}/${gate_entry_id}/shipments`
                this.shipmentData = []
                this.makeRequest("GET", url)
                    .then(result => {
                        this.isShipmentsLoading = false
                        this.shipmentData = result.data
                    })
                    .catch(e => {
                        this.isShipmentsLoading = false
                        this.displayError(e)
                    })
            }
        },
        activateReport() {
            this.isReportActive = true
        },
        deActivateReport() {
            this.isReportActive = false
        },
        getReports(tab="report", search={}) {
            this.isReportDataLoading = true
            let payload = {
                page: this[tab].page,
                rows: this[tab].pagelimit,
                vehicle_id: search.vehicle_id,
                start_date: search.start_date,
                end_date: search.end_date
            }
            this.makeRequest("POST", this[tab].url, payload)
                .then(result => {
                    this.isReportDataLoading = false
                    this[tab].list = result.data.data.rows
                    this[tab].totalcount = result.data.data.count
                    this[tab].pageCount = Math.ceil(result.data.data.count / this[tab].pagelimit)
                })
                .catch(e => {
                    this.isReportDataLoading = false
                    this.displayError(e)
                })
        },
        handlePageChange(pageNum, tab) {
            this[tab].pageoffset=pageNum
            this[tab].currPageNum = pageNum - 1

            this.getReports(tab, this.search);
            setTimeout(() => {
                $('html, body').animate({
                  scrollTop: $(`#${tab}`).offset().top -70
                });
            }, 500);
        },
        
    }
})
</script>
<style scoped>
.alignment{
    margin-left: 20px;
    margin-bottom: 20px;
}
.opened {
  background-color: #e3fafc;
}
.btn--export {
    border: none;
    padding: 6px 12px;
    color: #000;
    background: #fff;
    font-weight: 500
}
.btn--export:hover {
    color: #fff;
    background: #000
}
</style>